export default "/assets/mm_fr-blue.png";